/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMinus = createReactComponent("minus", "IconMinus", [
  ["path", { d: "M5 12l14 0", key: "svg-0" }]
]);

export { IconMinus as default };
//# sourceMappingURL=IconMinus.js.map
